import GrComponentFactory from "../../../gr_component_factory";
import GrPropTypes from "../../../shared/gr_prop_types";
import UserIcon from "../../../user/user_icon";
import { ICON_SIZES } from "../../../../modules/shape_icon_values";

export default GrComponentFactory.createClass({
  displayName: "AskTheAuthorInfoContainer",

  propTypes: {
    authorUser: GrPropTypes.author().isRequired,
    authorTagline: React.PropTypes.string.isRequired,
    ATAenabled: React.PropTypes.bool.isRequired,
    questionURL: React.PropTypes.string.isRequired,
    answerURL: React.PropTypes.string.isRequired,
    answersCount: React.PropTypes.string,
  },

  render() {
    return (
        <div className="askTheAuthorFeaturedListItemContainer gr-mediaFlexbox">
          <div className="gr-mediaFlexbox__media gr-mediaFlexbox__media--verticallyCentered">
            <UserIcon user={{ viewableName: this.props.authorUser.name,
                              profileImage: this.props.authorUser.profileImage,
                              profileUrl: this.props.authorUser.profileUrl }}
                      size={ICON_SIZES.MEDIUM}/>
          </div>

          <div className="gr-mediaFlexbox__desc">
            <div>
              <a href={this.props.authorUser.profileUrl}
                 className="askTheAuthorFeaturedListItemContainer__title gr-hyperlink">
                   {this.props.authorUser.name} </a>

                 {this.props.answersCount ?
                   <div className="askTheAuthorFeaturedListItemContainer__answersCount u-inlineBlock">
                     <a href={this.props.answerURL}
                        className="gr-hyperlink">{this.props.answersCount} </a>
                   </div>
                   : null}
            </div>

            <div>
              <div className="askTheAuthorFeaturedListItemContainer__authorTagline gr-metaText">
                {this.props.authorTagline}
              </div>
            </div>
          </div>

          {this.props.ATAenabled ?
            <div className={"askTheAuthorFeaturedListItemContainer__button"}>
              <a href={this.props.questionURL}
                 className="gr-button"
                 aria-label="Ask {this.props.authorUser.name} a question">
                   Ask </a>
            </div>
            : null}

        </div>
    );
  },
});
